import React from "react";
import { Menu, MenuItem } from "@mui/material";

import "./Navbar.scss";
import { SignOut } from "../svg/svgImageList";
import useThemeService from "../../services/theme-service/ThemeService";
import { translationService } from "../../services/translation/TranslationService";

export interface HeaderProfileMenuProps {
  isVisible: boolean;
  anchorElement: HTMLElement | null;
  close: () => void;
  onLogout?(): void;
  children?: any;
}

export default function HeaderProfileMenu(props: HeaderProfileMenuProps) {
  const { themeClass } = useThemeService();

  const { isVisible, anchorElement, close } = props;

  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorElement}
      className="navbar-header-profile-menu"
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isVisible}
      onClose={close}
    >
      {props.children}
      {props.onLogout && <MenuItem id="navbar-sign-out" className="navbar-sign-out" onClick={props.onLogout}>
        {translationService.translate("general.sign-out")}
        <SignOut className={themeClass(["sign-out-icon"])} />
      </MenuItem>}
    </Menu>
  );
}
